import script from './ManualReqFormInfo.vue2.js';
import normalizeComponent from '../../../../../../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';
import createInjector from '../../../../../../../../node_modules/vue-runtime-helpers/dist/inject-style/browser.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.procedure
    ? _c(
        "BasicCard",
        {
          staticClass: "ManualReqForm",
          attrs: {
            alignLeft: "",
            cardStyle: "white-with-border",
            boxShadow: ""
          }
        },
        [
          _vm.patient && _vm.patient.info
            ? _c("div", { staticClass: "ManualReqForm__section" }, [
                _c("div", { staticClass: "ManualReqForm__section-title" }, [
                  _vm._v("\n      Section 1: Patient details\n    ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ManualReqForm__section-content" }, [
                  _c(
                    "div",
                    [
                      _vm.patientName
                        ? _c("span", [_vm._v(_vm._s(_vm.patientName) + ", ")])
                        : _c("b-skeleton", { attrs: { width: "100" } }),
                      _vm._v(" "),
                      _vm.patientDOB
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.patientDOB) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.patient.info.gender
                        ? _c("div", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.capitalize(_vm.patient.info.gender)
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.patientPhone
                        ? _c("div", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.patientPhone) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("span", [_vm._v("Born")]),
                      _vm._v(" "),
                      _vm.patientDOB
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.patientDOB) +
                                "\n        "
                            )
                          ])
                        : _c("b-skeleton", { attrs: { width: "100" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.patientAddress
                    ? _c(
                        "div",
                        _vm._l(_vm.patientAddress, function(addressLine) {
                          return _c("div", { key: addressLine }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(addressLine) +
                                "\n        "
                            )
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.patient.insuranceInfo
                    ? _c(
                        "div",
                        _vm._l(_vm.patient.insuranceInfo, function(
                          insuranceEntry,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: insuranceEntry.carrier,
                              staticClass: "mt-2"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ManualReqForm__section-subtitle"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        index === 0
                                          ? "Primary"
                                          : index === 1
                                          ? "Secondary"
                                          : "Additional"
                                      ) +
                                      " insurance\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              insuranceEntry.carrier
                                ? _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(insuranceEntry.carrier) +
                                        "\n          "
                                    )
                                  ])
                                : _c("b-skeleton", { attrs: { width: "100" } }),
                              _vm._v(" "),
                              insuranceEntry.planType
                                ? _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(insuranceEntry.planType) +
                                        "\n          "
                                    )
                                  ])
                                : _c("b-skeleton", { attrs: { width: "100" } }),
                              _vm._v(" "),
                              insuranceEntry.number
                                ? _c("div", [
                                    _vm._v(
                                      "\n            ID: " +
                                        _vm._s(insuranceEntry.number) +
                                        "\n          "
                                    )
                                  ])
                                : _c("b-skeleton", { attrs: { width: "100" } }),
                              _vm._v(" "),
                              insuranceEntry.groupNumber
                                ? _c("div", [
                                    _vm._v(
                                      "\n            Group number: " +
                                        _vm._s(insuranceEntry.groupNumber) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              insuranceEntry.policyHolderInfo
                                ? _c(
                                    "div",
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n              Policy holder: " +
                                            _vm._s(
                                              insuranceEntry.policyHolderInfo
                                                .relationship
                                            ) +
                                            "\n            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.getPolicyHolderName(
                                                insuranceEntry
                                              )
                                            ) +
                                            ", " +
                                            _vm._s(
                                              _vm.getPolicyHolderDOB(
                                                insuranceEntry
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.getPolicyHolderAddress(insuranceEntry)
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.getPolicyHolderAddress(
                                                insuranceEntry
                                              ),
                                              function(addressLine) {
                                                return _c(
                                                  "div",
                                                  { key: addressLine },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(addressLine) +
                                                        "\n              "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _c("b-skeleton", {
                                            attrs: { width: "100" }
                                          })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.procedure && _vm.procedure.billTo
                    ? _c("div", { staticClass: "mt-2" }, [
                        _c(
                          "div",
                          { staticClass: "ManualReqForm__section-subtitle" },
                          [_vm._v("\n          Billing preferences\n        ")]
                        ),
                        _vm._v(
                          "\n        Bill to " +
                            _vm._s(_vm.procedure.billTo) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _c("b-skeleton", { attrs: { width: "100%" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ManualReqForm__section" },
            [
              _c("div", { staticClass: "ManualReqForm__section-title" }, [
                _vm._v("\n      Section 2: Collection information\n    ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ManualReqForm__section-content" }, [
                _c("div", [
                  _vm._v(
                    "Priority: " +
                      _vm._s(_vm.capitalize(_vm.procedure.labPriority))
                  )
                ]),
                _vm._v(" "),
                _vm.collectionDate
                  ? _c("div", [
                      _vm._v(
                        "\n        Collected on: " +
                          _vm._s(_vm.collectionDate) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.fastingRequired
                  ? _c("div", [_vm._v("\n        Fasting required\n      ")])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v("Collected by: Write your name on this field")
                ])
              ]),
              _vm._v(" "),
              _vm.placeGroup && _vm.placeAccount
                ? _c("div", { staticClass: "ManualReqForm__section" }, [
                    _c("div", { staticClass: "ManualReqForm__section-title" }, [
                      _vm._v(
                        "\n        Section 3: Client account information\n      "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ManualReqForm__section-content" },
                      [
                        _vm.placeGroup.name
                          ? _c("div", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.placeGroup.name) +
                                  "\n        "
                              )
                            ])
                          : _c("b-skeleton", { attrs: { width: "100" } }),
                        _vm._v(" "),
                        _vm.placeAccount.account
                          ? _c("div", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.placeAccount.account) +
                                  "\n        "
                              )
                            ])
                          : _c("b-skeleton", { attrs: { width: "100" } }),
                        _vm._v(" "),
                        _vm.placeAccount.name
                          ? _c("div", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.placeAccount.name) +
                                  "\n        "
                              )
                            ])
                          : _c("b-skeleton", { attrs: { width: "100" } }),
                        _vm._v(" "),
                        _vm.placeAccount.officeInfo
                          ? _c("div", [
                              _vm.placeAccountOfficeAddress
                                ? _c(
                                    "div",
                                    _vm._l(
                                      _vm.placeAccountOfficeAddress,
                                      function(addressLine) {
                                        return _c("div", { key: addressLine }, [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(addressLine) +
                                              "\n            "
                                          )
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.placeAccount.officeInfo.fax
                                ? _c("div", [
                                    _vm._v(
                                      "\n            Fax: " +
                                        _vm._s(
                                          _vm.formatPhoneNumber(
                                            _vm.placeAccount.officeInfo.fax
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.placeAccount.officeInfo.phone
                                ? _c("div", [
                                    _vm._v(
                                      "\n            Phone: " +
                                        _vm._s(
                                          _vm.formatPhoneNumber(
                                            _vm.placeAccount.officeInfo.phone
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _c("b-skeleton", { attrs: { width: "100%" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ManualReqForm__section" },
                [
                  _vm.prescriber
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "ManualReqForm__section-title" },
                          [
                            _vm._v(
                              "\n          Section 4: Ordering physician information\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ManualReqForm__section-content" },
                          [
                            _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.prescriberName) +
                                  "\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.prescriber.professionalInfo
                              ? _c("div", [
                                  _vm._v(
                                    "\n            NPI: " +
                                      _vm._s(
                                        _vm.prescriber.professionalInfo.npi
                                      ) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.procedure.ccAccounts
                              ? _c(
                                  "div",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ManualReqForm__section-subtitle"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Please fax a copy of all results to\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.procedure.ccAccounts, function(
                                      account
                                    ) {
                                      return _c("div", { key: account.id }, [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(account.firstName) +
                                            " " +
                                            _vm._s(account.lastName) +
                                            ", Fax: " +
                                            _vm._s(
                                              _vm.formatPhoneNumber(account.fax)
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _c("b-skeleton", { attrs: { width: "100%" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ManualReqForm__section" },
                [
                  _vm.diagnosis
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "ManualReqForm__section-title" },
                          [
                            _vm._v(
                              "\n          Section 5: ICD-10 diagnosis codes\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ManualReqForm__section-content" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.diagnosis) +
                                "\n        "
                            )
                          ]
                        )
                      ])
                    : _c("b-skeleton", { attrs: { width: "100%" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "ManualReqForm__section ManualReqForm__section--no-border"
                },
                [
                  _vm.products
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "ManualReqForm__section-title" },
                          [
                            _vm._v(
                              "\n          Section 6: Ordered Tests\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ManualReqForm__section-content" },
                          [
                            _c("div", [
                              _vm._v(
                                "\n            Please add the tests below to the requisition form. If the test\n            name matches exactly with an existing test on the requisition\n            form, please check the test box. Otherwise write in the test\n            code, CPT code, and test name "
                              ),
                              _c("b", [_vm._v("exactly as shown below")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass: "ManualReqForm__ul lst-disc mt-2"
                              },
                              _vm._l(_vm.products, function(product) {
                                return _c("li", { key: product.id }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.getProductInfo(product)) +
                                      "\n            "
                                  )
                                ])
                              }),
                              0
                            )
                          ]
                        )
                      ])
                    : _c("b-skeleton", { attrs: { width: "100%" } })
                ],
                1
              ),
              _vm._v(" "),
              _vm.labInstructions
                ? _c("div", { staticClass: "ManualReqForm__section" }, [
                    _c("div", { staticClass: "ManualReqForm__section-title" }, [
                      _vm._v("\n        Additional annotations\n      ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ManualReqForm__section-content" },
                      [
                        _c("div", [
                          _vm._v(
                            "Please write the following across the top of the requisition form, next to the barcode:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-2" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.labInstructions) +
                              "\n        "
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-26d15c9b_0", { source: "/** I feel like we need to improve the naming convention here */\n.background-green-25[data-v-26d15c9b] {\n  background-color: #F6FEF9;\n}\n.background-purple-50[data-v-26d15c9b] {\n  background-color: #F9F5FF;\n}\n.background-blue-25[data-v-26d15c9b] {\n  background-color: #F5F8FF;\n}\n.background-red-25[data-v-26d15c9b] {\n  background-color: #FFFBFA;\n}\n.background-orange-50[data-v-26d15c9b] {\n  background-color: #FFFAEB;\n}\n\n/** --------------------------- BRAND VARIABLES ---------------------------- **/\n/** ---------------------------- COLOR PALETTE ----------------------------- **/\n/** ------------------------- TEXT & ICON PALETTE -------------------------- **/\n/** ---------------------------- LINK PALETTE ------------------------------ **/\n/** --------------------------- BUTTON PALETTE ----------------------------- **/\n/** --------------------------- INPUT STYLES ----------------------------- **/\n/** ---------------------------- MAP STYLES ----------------------------- **/\n/** ---------------------------- TOAST STYLES ----------------------------- **/\n/* Bulma Utilities */\n/** dash-size (1: solid, 2: 2 on/2 off, 3: 8 on/8 off, 4: 16 on/16 off) */\n/**\n * * Dashed-border does not behave nicely with real borders, if using, do not\n * * use border.\n * */\n.ManualReqForm[data-v-26d15c9b] {\n  height: fit-content;\n  width: 100%;\n  padding: 0 12px;\n  margin: 0 12px;\n}\n.ManualReqForm__section[data-v-26d15c9b] {\n  text-align: left;\n  padding: 10px 0;\n}\n.ManualReqForm__section-title[data-v-26d15c9b] {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n.ManualReqForm__section-subtitle[data-v-26d15c9b] {\n  font-weight: 600;\n}\n.ManualReqForm__section-content[data-v-26d15c9b] {\n  color: #696F8C;\n  font-size: 14px;\n  font-weight: 400;\n}\n.ManualReqForm__ul[data-v-26d15c9b] {\n  padding-left: 24px;\n}\n\n/*# sourceMappingURL=ManualReqFormInfo.vue.map */", map: {"version":3,"sources":["ManualReqFormInfo.vue","/builds/caresend/deploy/ui-components/src/components/specific/portal/components/Workflow/DropOffDetails/components/ManualReqFormInfo.vue"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;ACqf/E,+EAAA;ADnfA,+EAA+E;AAC/E,6EAA6E;AAC7E,4EAA4E;AAC5E,8EAA8E;AAC9E,oBAAoB;AACpB,yEAAyE;AACzE;;;IAGI;ACmeJ;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EDjeE,cAAc;AAChB;ACmeA;EACA,gBAAA;EACA,eAAA;ADheA;ACieA;EACA,gBAAA;EACA,eAAA;ED9dE,kBAAkB;AACpB;ACgeA;ED7dE,gBAAgB;AAClB;AC+dA;EACA,cAAA;EACA,eAAA;ED5dE,gBAAgB;AAClB;AC8dA;ED3dE,kBAAkB;AACpB;;AAEA,gDAAgD","file":"ManualReqFormInfo.vue","sourcesContent":["/** I feel like we need to improve the naming convention here */\n.background-green-25 {\n  background-color: #F6FEF9;\n}\n\n.background-purple-50 {\n  background-color: #F9F5FF;\n}\n\n.background-blue-25 {\n  background-color: #F5F8FF;\n}\n\n.background-red-25 {\n  background-color: #FFFBFA;\n}\n\n.background-orange-50 {\n  background-color: #FFFAEB;\n}\n\n/** --------------------------- BRAND VARIABLES ---------------------------- **/\n/** ---------------------------- COLOR PALETTE ----------------------------- **/\n/** ------------------------- TEXT & ICON PALETTE -------------------------- **/\n/** ---------------------------- LINK PALETTE ------------------------------ **/\n/** --------------------------- BUTTON PALETTE ----------------------------- **/\n/** --------------------------- INPUT STYLES ----------------------------- **/\n/** ---------------------------- MAP STYLES ----------------------------- **/\n/** ---------------------------- TOAST STYLES ----------------------------- **/\n/* Bulma Utilities */\n/** dash-size (1: solid, 2: 2 on/2 off, 3: 8 on/8 off, 4: 16 on/16 off) */\n/**\n * * Dashed-border does not behave nicely with real borders, if using, do not\n * * use border.\n * */\n.ManualReqForm {\n  height: fit-content;\n  width: 100%;\n  padding: 0 12px;\n  margin: 0 12px;\n}\n\n.ManualReqForm__section {\n  text-align: left;\n  padding: 10px 0;\n}\n\n.ManualReqForm__section-title {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.ManualReqForm__section-subtitle {\n  font-weight: 600;\n}\n\n.ManualReqForm__section-content {\n  color: #696F8C;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.ManualReqForm__ul {\n  padding-left: 24px;\n}\n\n/*# sourceMappingURL=ManualReqFormInfo.vue.map */","<template>\n  <BasicCard\n    v-if=\"procedure\"\n    alignLeft\n    cardStyle=\"white-with-border\"\n    class=\"ManualReqForm\"\n    boxShadow\n  >\n    <div\n      v-if=\"patient && patient.info\"\n      class=\"ManualReqForm__section\"\n    >\n      <div class=\"ManualReqForm__section-title\">\n        Section 1: Patient details\n      </div>\n      <div class=\"ManualReqForm__section-content\">\n        <div>\n          <span v-if=\"patientName\">{{ patientName }}, </span>\n          <b-skeleton\n            v-else\n            width=\"100\"\n          />\n          <span v-if=\"patientDOB\">\n            {{ patientDOB }}\n          </span>\n          <div v-if=\"patient.info.gender\">\n            {{ capitalize(patient.info.gender) }}\n          </div>\n          <div v-if=\"patientPhone\">\n            {{ patientPhone }}\n          </div>\n        </div>\n        <div>\n          <span>Born</span>\n          <span v-if=\"patientDOB\">\n            {{ patientDOB }}\n          </span>\n          <b-skeleton\n            v-else\n            width=\"100\"\n          />\n        </div>\n        <div v-if=\"patientAddress\">\n          <div\n            v-for=\"addressLine in patientAddress\"\n            :key=\"addressLine\"\n          >\n            {{ addressLine }}\n          </div>\n        </div>\n        <div v-if=\"patient.insuranceInfo\">\n          <div\n            v-for=\"(insuranceEntry, index) in patient.insuranceInfo\"\n            :key=\"insuranceEntry.carrier\"\n            class=\"mt-2\"\n          >\n            <div class=\"ManualReqForm__section-subtitle\">\n              {{ index === 0 ? 'Primary' : index === 1 ? 'Secondary' : 'Additional' }} insurance\n            </div>\n            <div v-if=\"insuranceEntry.carrier\">\n              {{ insuranceEntry.carrier }}\n            </div>\n            <b-skeleton\n              v-else\n              width=\"100\"\n            />\n            <div v-if=\"insuranceEntry.planType\">\n              {{ insuranceEntry.planType }}\n            </div>\n            <b-skeleton\n              v-else\n              width=\"100\"\n            />\n            <div v-if=\"insuranceEntry.number\">\n              ID: {{ insuranceEntry.number }}\n            </div>\n            <b-skeleton\n              v-else\n              width=\"100\"\n            />\n            <div v-if=\"insuranceEntry.groupNumber\">\n              Group number: {{ insuranceEntry.groupNumber }}\n            </div>\n            <div v-if=\"insuranceEntry.policyHolderInfo\">\n              <div>\n                Policy holder: {{ insuranceEntry.policyHolderInfo.relationship }}\n              </div>\n              <div>\n                {{ getPolicyHolderName(insuranceEntry) }}, {{ getPolicyHolderDOB(insuranceEntry) }}\n              </div>\n              <div v-if=\"getPolicyHolderAddress(insuranceEntry)\">\n                <div\n                  v-for=\"addressLine in getPolicyHolderAddress(insuranceEntry)\"\n                  :key=\"addressLine\"\n                >\n                  {{ addressLine }}\n                </div>\n              </div>\n              <b-skeleton\n                v-else\n                width=\"100\"\n              />\n            </div>\n          </div>\n        </div>\n        <div\n          v-if=\"procedure && procedure.billTo\"\n          class=\"mt-2\"\n        >\n          <div class=\"ManualReqForm__section-subtitle\">\n            Billing preferences\n          </div>\n          Bill to {{ procedure.billTo }}\n        </div>\n      </div>\n    </div>\n    <b-skeleton\n      v-else\n      width=\"100%\"\n    />\n    <div class=\"ManualReqForm__section\">\n      <div class=\"ManualReqForm__section-title\">\n        Section 2: Collection information\n      </div>\n      <div class=\"ManualReqForm__section-content\">\n        <div>Priority: {{ capitalize(procedure.labPriority) }}</div>\n        <div v-if=\"collectionDate\">\n          Collected on: {{ collectionDate }}\n        </div>\n        <div v-if=\"fastingRequired\">\n          Fasting required\n        </div>\n        <div>Collected by: Write your name on this field</div>\n      </div>\n      <div\n        v-if=\"placeGroup && placeAccount\"\n        class=\"ManualReqForm__section\"\n      >\n        <div class=\"ManualReqForm__section-title\">\n          Section 3: Client account information\n        </div>\n        <div class=\"ManualReqForm__section-content\">\n          <div v-if=\"placeGroup.name\">\n            {{ placeGroup.name }}\n          </div>\n          <b-skeleton\n            v-else\n            width=\"100\"\n          />\n          <div v-if=\"placeAccount.account\">\n            {{ placeAccount.account }}\n          </div>\n          <b-skeleton\n            v-else\n            width=\"100\"\n          />\n          <div v-if=\"placeAccount.name\">\n            {{ placeAccount.name }}\n          </div>\n          <b-skeleton\n            v-else\n            width=\"100\"\n          />\n          <div v-if=\"placeAccount.officeInfo\">\n            <div v-if=\"placeAccountOfficeAddress\">\n              <div\n                v-for=\"addressLine in placeAccountOfficeAddress\"\n                :key=\"addressLine\"\n              >\n                {{ addressLine }}\n              </div>\n            </div>\n            <div v-if=\"placeAccount.officeInfo.fax\">\n              Fax: {{ formatPhoneNumber(placeAccount.officeInfo.fax) }}\n            </div>\n            <div v-if=\"placeAccount.officeInfo.phone\">\n              Phone: {{ formatPhoneNumber(placeAccount.officeInfo.phone) }}\n            </div>\n          </div>\n        </div>\n      </div>\n      <b-skeleton\n        v-else\n        width=\"100%\"\n      />\n      <div class=\"ManualReqForm__section\">\n        <div v-if=\"prescriber\">\n          <div class=\"ManualReqForm__section-title\">\n            Section 4: Ordering physician information\n          </div>\n          <div class=\"ManualReqForm__section-content\">\n            <div>\n              {{ prescriberName }}\n            </div>\n            <div v-if=\"prescriber.professionalInfo\">\n              NPI: {{ prescriber.professionalInfo.npi }}\n            </div>\n            <div\n              v-if=\"procedure.ccAccounts\"\n              class=\"mt-2\"\n            >\n              <div class=\"ManualReqForm__section-subtitle\">\n                Please fax a copy of all results to\n              </div>\n              <div\n                v-for=\"account in procedure.ccAccounts\"\n                :key=\"account.id\"\n              >\n                {{ account.firstName }} {{ account.lastName }}, Fax: {{ formatPhoneNumber(account.fax) }}\n              </div>\n            </div>\n          </div>\n        </div>\n        <b-skeleton\n          v-else\n          width=\"100%\"\n        />\n      </div>\n      <div class=\"ManualReqForm__section\">\n        <div v-if=\"diagnosis\">\n          <div class=\"ManualReqForm__section-title\">\n            Section 5: ICD-10 diagnosis codes\n          </div>\n          <div class=\"ManualReqForm__section-content\">\n            {{ diagnosis }}\n          </div>\n        </div>\n        <b-skeleton\n          v-else\n          width=\"100%\"\n        />\n      </div>\n      <div class=\"ManualReqForm__section ManualReqForm__section--no-border\">\n        <div v-if=\"products\">\n          <div class=\"ManualReqForm__section-title\">\n            Section 6: Ordered Tests\n          </div>\n          <div class=\"ManualReqForm__section-content\">\n            <div>\n              Please add the tests below to the requisition form. If the test\n              name matches exactly with an existing test on the requisition\n              form, please check the test box. Otherwise write in the test\n              code, CPT code, and test name <b>exactly as shown below</b>\n            </div>\n            <ul class=\"ManualReqForm__ul lst-disc mt-2\">\n              <li\n                v-for=\"product in products\"\n                :key=\"product.id\"\n              >\n                {{ getProductInfo(product) }}\n              </li>\n            </ul>\n          </div>\n        </div>\n        <b-skeleton\n          v-else\n          width=\"100%\"\n        />\n      </div>\n      <div\n        v-if=\"labInstructions\"\n        class=\"ManualReqForm__section\"\n      >\n        <div class=\"ManualReqForm__section-title\">\n          Additional annotations\n        </div>\n        <div class=\"ManualReqForm__section-content\">\n          <div>Please write the following across the top of the requisition form, next to the barcode:</div>\n          <div class=\"mt-2\">\n            {{ labInstructions }}\n          </div>\n        </div>\n      </div>\n    </div>\n  </BasicCard>\n</template>\n\n<script lang=\"ts\">\nimport {\n  Booking,\n  DbRef,\n  EncryptedFile,\n  EncryptedUser,\n  Instruction,\n  InstructionType,\n  InsuranceInfo,\n  PlaceAccount,\n  PlaceGroup,\n  PlaceGroupProductConfig,\n  ProcedureDocumentType,\n  Product,\n  StaffUser,\n  Waypoint,\n  WaypointType,\n  YesNoOptionLabel,\n} from '@caresend/types';\nimport {\n  AddressFormatType,\n  capitalize,\n  formatAddressUS,\n  formatDateOfBirth,\n  formatFullName,\n  formatPhoneNumber,\n  formatTimeZoneDateSimple,\n  getInstruction,\n  getProcedureDocumentsByType,\n  isNullish,\n  nullishFilter,\n  procedureDateInfo,\n} from '@caresend/utils';\nimport { computed, defineComponent } from 'vue';\n\nimport BasicCard from '@components/cards/BasicCard/BasicCard.vue';\nimport { usePortalStore } from '@components/specific/portal/store/portal';\nimport { getStore } from '@store/helpers/initStore';\n\nexport default defineComponent({\n  name: 'ManualReqFormInfo',\n  components: {\n    BasicCard,\n  },\n  props: {\n    procedureID: {\n      type: String,\n      required: true,\n    },\n  },\n  setup(props) {\n    const store = getStore();\n    const portalStore = usePortalStore();\n\n    const procedure = computed(() =>\n      portalStore.procedures.get(props.procedureID),\n    );\n\n    const instructionalRequisitionForm = computed<EncryptedFile | undefined>(\n      () => getProcedureDocumentsByType(\n        procedure.value ?? undefined,\n        ProcedureDocumentType.INSTRUCTIONAL_REQUISITION_FORM,\n      )?.[0]?.file,\n    );\n\n    const booking = computed<Booking | undefined>(\n      () => procedure.value?.computed.booking,\n    );\n\n    const patient = computed<Partial<EncryptedUser> | undefined>(() => {\n      if (\n        isNullish(booking.value)\n        || isNullish(booking.value.patientID)\n      ) return;\n      return store.getters['users/getUserByID'](booking.value.patientID) ?? undefined;\n    });\n\n    const patientName = computed<string | undefined>(() => {\n      if (patient.value === undefined) return;\n      return formatFullName(patient.value);\n    });\n\n    const patientPhone = computed<string | undefined>(() => formatPhoneNumber(patient.value?.info?.phone));\n\n    const patientDOB = computed(() => {\n      if (!patient.value?.info?.dateOfBirth) return;\n      return formatDateOfBirth(patient.value.info.dateOfBirth);\n    });\n\n    const waypoint = computed<Waypoint | null>(() =>\n      Object.values(procedure.value?.computed.waypoints ?? {})\n        .find((wp) => wp.type === WaypointType.PATIENT) ?? null,\n    );\n\n    const collectionDate = computed<string | undefined>(() =>\n      formatTimeZoneDateSimple(waypoint.value?.date)\n      ?? procedureDateInfo(procedure.value?.dateInfo),\n    );\n\n    const fastingRequired = computed<boolean>(() => procedure.value?.instructions?.some((instr: Instruction) =>\n      instr.type === InstructionType.FASTING && instr.instruction !== YesNoOptionLabel.NO) ?? false,\n    );\n\n    const patientAddress = computed<string[] | undefined>(() => {\n      if (!patient.value?.info?.address?.addressComponents) {\n        if (!waypoint.value?.location) return;\n        return formatAddressUS(waypoint.value.location, undefined, AddressFormatType.MULTI_LINE);\n      }\n      return formatAddressUS(patient.value?.info?.address, undefined, AddressFormatType.MULTI_LINE);\n    });\n\n    const placeAccount = computed<PlaceAccount | null>(() => {\n      const id = Object.keys(procedure.value?.placeAccounts ?? {})?.[0];\n      if (isNullish(id)) return null;\n      return portalStore[DbRef.PLACE_ACCOUNTS].getRaw(id);\n    });\n\n    const placeAccountOfficeAddress = computed<string[] | undefined>(() => {\n      if (!placeAccount.value?.officeInfo?.address) return;\n      return formatAddressUS(placeAccount.value.officeInfo.address, undefined, AddressFormatType.MULTI_LINE);\n    });\n\n    const placeGroup = computed<PlaceGroup | null>(() => {\n      if (waypoint.value?.placeID) {\n        const { placeID } = waypoint.value;\n        const place = portalStore[DbRef.PLACES].getRaw(placeID);\n        if (place?.placeGroupID) {\n          const { placeGroupID } = place;\n          return portalStore[DbRef.PLACE_GROUPS].getRaw(placeGroupID);\n        }\n      }\n      if (placeAccount.value?.privatePlaceGroup) return placeAccount.value.privatePlaceGroup;\n      if (!placeAccount.value?.placeGroupID) return null;\n      return portalStore[DbRef.PLACE_GROUPS].getRaw(placeAccount.value?.placeGroupID);\n    });\n\n    const policyHolderDOB = computed<string | null>(() => {\n      if (!patient.value || !patient.value?.insuranceInfo || !patient.value.insuranceInfo[0]) return null;\n      const insuranceInfo = patient.value.insuranceInfo[0];\n      if (!insuranceInfo.policyHolderInfo || !insuranceInfo?.policyHolderInfo.dateOfBirth) return null;\n      return formatDateOfBirth(insuranceInfo.policyHolderInfo.dateOfBirth);\n    });\n\n    const getPolicyHolderDOB = (insuranceEntry: InsuranceInfo): string | undefined => {\n      if (!insuranceEntry?.policyHolderInfo) return patientDOB.value;\n      return formatDateOfBirth(insuranceEntry.policyHolderInfo.dateOfBirth);\n    };\n\n    const getPolicyHolderAddress = (insuranceEntry: InsuranceInfo): string[] => {\n      if (!insuranceEntry.policyHolderInfo) return [];\n      return formatAddressUS(insuranceEntry.policyHolderInfo.address, undefined, AddressFormatType.MULTI_LINE);\n    };\n\n    const getPolicyHolderName = (insuranceEntry: InsuranceInfo): string | undefined => {\n      if (!insuranceEntry.policyHolderInfo) return;\n      return `${insuranceEntry.policyHolderInfo.firstName} ${insuranceEntry.policyHolderInfo.lastName}`;\n    };\n\n    const prescriber = computed<Partial<StaffUser> | undefined | null>(() => procedure.value?.computed.prescriber);\n\n    const prescriberName = computed<string | null>(() => {\n      if (!prescriber.value) return null;\n      return formatFullName(prescriber.value);\n    });\n\n    const diagnosis = computed(() => getInstruction(\n      procedure.value?.instructions,\n      InstructionType.DIAGNOSIS,\n    )?.instruction);\n\n    const products = computed<Product[]>(() => {\n      const productIDs = Object.keys(procedure.value?.products ?? {});\n      return productIDs.map(\n        (productID) => store.state.variables.variables?.products[productID],\n      ).filter(nullishFilter);\n    });\n\n    const getPlaceGroupConfig = (product: Product): PlaceGroupProductConfig | null => {\n      const placeGroupID = placeGroup.value?.id;\n      if (!placeGroupID) return null;\n\n      return product.placeGroups?.[placeGroupID] ?? null;\n    };\n\n    /**\n     * Returns product info based on procedure's place group.\n     *\n     * Examples:\n     * - Matching place group config found:\n     *   - `(LAB CODE) Lab friendly name (LAB CPT CODES, ...)`\n     * - No matching place group config found:\n     *   - `Product name`\n     */\n    const getProductInfo = (product: Product) => {\n      const placeGroupConfig = getPlaceGroupConfig(product);\n\n      if (!placeGroupConfig) return product.name;\n\n      const { labCode, cptCodes, friendlyName } = placeGroupConfig;\n      return `(${labCode}) ${friendlyName} (${cptCodes.join(', ')})`;\n    };\n\n    const labInstructions = computed<string | undefined>(() => procedure.value?.instructions?.find(\n      (instruction) => instruction.type === InstructionType.LAB)?.instruction,\n    );\n\n    return {\n      capitalize,\n      collectionDate,\n      diagnosis,\n      fastingRequired,\n      formatAddressUS,\n      formatPhoneNumber,\n      getPolicyHolderAddress,\n      getPolicyHolderDOB,\n      getPolicyHolderName,\n      getProductInfo,\n      instructionalRequisitionForm,\n      labInstructions,\n      patient,\n      patientAddress,\n      patientDOB,\n      patientName,\n      patientPhone,\n      placeAccount,\n      placeAccountOfficeAddress,\n      placeGroup,\n      policyHolderDOB,\n      prescriber,\n      prescriberName,\n      procedure,\n      products,\n      waypoint,\n    };\n  },\n});\n</script>\n\n<style lang=\"sass\" scoped>\n.ManualReqForm\n  height: fit-content\n  width: 100%\n  padding: 0 12px\n  margin: 0 12px\n\n.ManualReqForm__section\n  text-align: left\n  padding: 10px 0\n.ManualReqForm__section-title\n  font-weight: $cs-font-weight-semi-bold\n  font-size: 16px\n  margin-bottom: 8px\n\n.ManualReqForm__section-subtitle\n  font-weight: $cs-font-weight-semi-bold\n\n.ManualReqForm__section-content\n  color: $cs-grey-700\n  font-size: 14px\n  font-weight: $cs-font-weight-regular\n\n.ManualReqForm__ul\n  padding-left: 24px\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-26d15c9b";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__ as default };
